<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('inventory.operation.stock_adjustment.stock_adjustment') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('inventory.operation.stock_adjustment.stock_adjustment'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-9">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'stock-adjustment-create' })"
            >
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              class="mr-2"
            />
            <ts-button
              outline
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'adjustment_date'
          }"
        >
          <template v-slot="{ record }">
            <td>{{ record.branch_name }}</td>
            <td class="text-center">{{ record.adj_number }}</td>
            <td>{{ record.note }}</td>
            <td class="text-center ts-flex ts-space-x-3">
              <a href="#" v-tooltip="$t('view')" @click.prevent="edit(record)">
                <i class="fas fa-eye"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('delete')"
                class="text-danger"
                @click.prevent="destroy(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
    <a-drawer
      :title="$t('filter')"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="() => (visible = false)"
      :zIndex="1020"
      width="300px"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <a-select
              style="width: 257px"
              v-model="branch_id"
              :options="branchs"
              showSearch
              mode="multiple"
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              :maxTagCount="1"
              :maxTagTextLength="17"
              :placeholder="$t('all')"
            >
            </a-select>
          </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'stock-adjustment',
  data() {
    return {
      loading: false,
      visible: false,
      branchs: []
    }
  },
  computed: {
    ...mapState('stockAdjustment', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.stockAdjustment.search
      },
      set(newValue) {
        this.$store.commit('stockAdjustment/SET_SEARCH', newValue)
        this.$store.commit('stockAdjustment/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get() {
        return this.$store.state.stockAdjustment.branch_id
      },
      set(newValue) {
        this.$store.commit('stockAdjustment/SET_BRANCH_ID', newValue)
      }
    },
    columns() {
      return [
        {
          name: this.$t('inventory.operation.stock_adjustment.branch'),
          style: 'width:15%'
        },
        {
          name: this.$t(
            'inventory.operation.stock_adjustment.adjustment_number'
          ),
          style: 'text-align:center; width:12%'
        },
        { name: this.$t('inventory.operation.stock_adjustment.note') },
        {
          name: this.$t('inventory.operation.stock_adjustment.actions'),
          style: 'text-align:center; width:7%'
        }
      ]
    }
  },
  created() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'stockAdjustment/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    edit(record) {
      this.$store.commit('stockAdjustment/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'stock-adjustment-edit',
        params: { id: record.stock_adjustment_id }
      })
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('stockAdjustment/destroy', record.stock_adjustment_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'stock-adjustment-create') {
      this.$store.commit('stockAdjustment/RESET_STATE')
    }
    next()
  }
}
</script>
